<template>
    <div class="bagdes-page-wrap">
        <div class="current-badges">
            <UserBadges 
                :badges="badges"
                @badge="setSelectedBadge"
                @delete-badge="deleteBadge"
            />
        </div>
        <div class="edit-wrap">
            <div class="left">
                <div class="name">
                    <h3>Badge name</h3>
                    <input v-model="selectedBadge.bgd_name" type="text">
                </div>
                <div class="name">
                    <h3>Badge description</h3>
                    <textarea :value="selectedBadge.bgd_desc" @input="selectedBadge.bgd_desc = $event.target.value"></textarea>
                </div>
                <div class="img-wrap" :class="{ 'empty' : !currentImageURL }" @mouseenter="toggleHover" @mouseleave="toggleHover">
                    <img :src="currentImageURL" alt="">
                    <transition name="arrow">
                        <div v-if="isHoveringImage" class="overlay">
                            <label for="input">
                                <img :src="$images.plus" alt="upload-picture">
                            </label>
                            <input type="file" id="input" @change="getFile">
                            <div v-if="newImage" class="x" @click="newImage = null">
                                <img :src="$images.plus" alt="del-btn">
                            </div>
                        </div>
                    </transition>
                </div>
                <span>PNG only</span>
            </div>
            <div class="right">
                <h3>Set badge requirements</h3>
                <div class="dropdown-wrap" v-if="!selectedBadge.evn_id">
                    <label>Answers</label>
                    <select name="questions" v-model="selectedBadge.pqa_id">
                        <option :value="null">None</option>
                        <option
                            v-for="answer in answers"
                            :key="answer.pqa_id"
                            :value="answer.pqa_id"
                        >
                            {{ answer.pqa_text }}
                        </option>
                    </select>
                </div>
                <div class="dropdown-wrap" v-if="!selectedBadge.pqa_id">
                    <label>Events</label>
                    <select name="questions" v-model="selectedBadge.evn_id">
                        <option :value="null">None</option>
                        <option
                            v-for="evt in events"
                            :key="evt.evn_id"
                            :value="evt.evn_id"
                        >
                            {{ evt.evn_name }}
                        </option>
                    </select>

                    <div class="input-wrap" v-if="selectedBadge.evn_id">
                        <label>Min points</label>
                        <input type="text" v-model="selectedBadge.bgd_min">
                    </div>
                    <div class="input-wrap" v-if="selectedBadge.evn_id">
                        <label>Max points</label>
                        <input type="text" v-model="selectedBadge.bgd_max">
                    </div>
                </div>
            </div>
        </div>
        <div class="button-line">
            <button @click="createBadge">
                {{ selectedBadge.isNew? 'Create badge' : 'Edit Badge' }}
            </button>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import UserBadges from "@/components/profile/UserBadges.vue";
const BADGE_STRUCTURE = {
    isNew: true,
    bgd_max: 0,
    bgd_min: 0,
    bgd_name: "",
    bgd_desc: "",
    evn_id: null,
    evn_name: null,
    pqa_id: null,
    pqa_text: null
}
export default {
    components: {
        UserBadges
    },
    data () {
        return {
            badges: [],
            selectedBadge: JSON.parse(JSON.stringify(BADGE_STRUCTURE)),
            answers: [],
            selectedAnswer: null,
            events: [],
            selectedEvent: null,
            isHoveringImage: false,
            newImage: null,
        };
    },
    watch: {
        selectedBadge: {
            handler () {
                this.newImage = null;
            },
        },
    },
    mounted () {
        this.init();
    },
    computed: {
        badgeImageURL() {
            const sid = localStorage.getItem('sid');
            const URL = this.selectedBadge.bgd_id? process.env.VUE_APP_API_URL+`/badges/image?bgd_id=${this.selectedBadge.bgd_id}&sid=${sid}` : null;
            return URL;
        },
        newImageURL () {
            return this.newImage? URL.createObjectURL(this.newImage) : null;
        },
        currentImageURL () {
           return this.newImageURL || this.badgeImageURL;
        },
    },
    methods: {
        async init () {
            await this.getEvents();
            await this.getAllQuestionAnswers();
            await this.getBadges();
        },
        async getBadges () {
            let apiObj = {
                api: api.getBadges,
                onError: () => this.stopLoading()
            }
            this.startLoading();
            const data = await this.apiCall(apiObj);
            if (data) {
                this.badges = data.res;
            }
            this.stopLoading();
        },
        async getEvents () {
            let apiObj = {
                api: api.getEvents,
                onError: () => this.stopLoading()
            }
            this.startLoading();
            const data = await this.apiCall(apiObj);
            if (data) {
                this.events = data.data;
            }
            this.stopLoading();
        },
        async getAllQuestionAnswers () {
            let apiObj = {
                api: api.getAllQuestionAnswers,
                onError: () => this.stopLoading()
            }
            this.startLoading();
            const data = await this.apiCall(apiObj);
            if (data) {
                this.answers = data.res;
            }
            this.stopLoading();
        },
        setSelectedBadge (badge) {
            if (this.selectedBadge.bgd_id === badge.bgd_id) this.selectedBadge = JSON.parse(JSON.stringify(BADGE_STRUCTURE));
            else this.selectedBadge = JSON.parse(JSON.stringify(badge));
        },
        deleteBadge(badge) {
			const confirmProp = {
				title: `Are you sure you want to delete ${badge.bgd_name} badge?`,
				okCallback: async () => {
					try {
						await api.deleteBadge({
                            bgd_id: badge.bgd_id
                        })
						this.openToast('Badge deleted.');
						this.init();
					} catch (error) {
						console.warn(error);
						this.customError(this.$t('Something went wrong.'))	
					}
				}
			}
			this.EventBus.$emit("confirm", confirmProp);
		},
        toggleHover () {
            this.isHoveringImage = !this.isHoveringImage;
        },
        getFile (evt) {
            this.newImage = evt.target.files[0];
        },
        async createBadge () {
            if (this.hasErrors()) return; 
            const formData = new FormData();
            if (this.selectedBadge.bgd_id) formData.append('bgd_id', this.selectedBadge.bgd_id);
            formData.append('bgd_name', this.selectedBadge.bgd_name);
            formData.append('bgd_desc', this.selectedBadge.bgd_desc);
            if (this.newImage) formData.append('bgd_image', this.newImage);
            if (this.selectedBadge.pqa_id) formData.append('pqa_id', this.selectedBadge.pqa_id);
            if (this.selectedBadge.evn_id) {
                formData.append('evn_id', this.selectedBadge.evn_id);
                formData.append('bgd_max', this.selectedBadge.bgd_max);
                formData.append('bgd_min', this.selectedBadge.bgd_min);
            }

            const apiObj = {
                api: this.selectedBadge.bgd_id? api.editBadge : api.postBadge,
                params: formData,
            };

            const data = await this.apiCall(apiObj);
            if (data) {
                await this.init();
                this.openToast(`Badge ${this.selectedBadge.bgd_id? 'updated' : 'created'}!`)
                this.selectedBadge = JSON.parse(JSON.stringify(BADGE_STRUCTURE));
            }
        },
        hasErrors () {
            if (this.selectedBadge.bgd_name.length === 0) {
                this.EventBus.$emit('error', {
                    message: 'Badge needs a name',
                });
                return true;
            }
            if (this.selectedBadge.isNew && !this.newImage) {
                this.EventBus.$emit('error', {
                    message: 'Badge needs an icon',
                });
                return true;
            }
            if (!this.selectedBadge.pqa_id && !this.selectedBadge.evn_id) {
                this.EventBus.$emit('error', {
                    message: 'Please set badge requirements',
                });
                return true;
            }

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>
.bagdes-page-wrap {
    padding: 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    .edit-wrap {
        display: flex;
        justify-content: center;
        margin-top: 3em;
        width: #{"min(60%, 40em)"};
        gap: 3em;
        .left {
            width: 60%;
            .name {
                input, textarea {
                    margin-bottom: 2em;
                }
                textarea {
                    width: 100%;
                    max-height: 400px;
                }
            }
            .img-wrap {
                min-height: 200px;
                max-height: 400px;
                width: 100%;
                position: relative;
                cursor: pointer;
                &.empty {
                    border: 1px dotted gray;
                }
                .overlay {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    top: 0;
                    right: 0;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, .3);
                    label {
                        img {
                            transform: scale(2);
                            cursor: pointer;
                        }
                    }
                    input {
                        display: none;
                    }
                    .x {
                        position: absolute;
                        top: 0px;
                        right: 3px;
                        cursor: pointer;
                        transform: rotate(45deg);
                    }
                }
                img {
                    width: 100%;
                    max-height: 400px;
                }
            }
        }
        .right {
            width: 40%;
            display: flex;
            flex-direction: column;
            .dropdown-wrap {
                display: flex;
                flex-direction: column;
                margin: 15px 0;
            }
        }
    }
    .button-line {
        button {
            margin-top: 3em;
            font-family: 'Roboto';
            font-size: 16px;
            font-weight: 500;
            color: white;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 20px 5px;
            min-width: 172px;
            height: 39px;
            border-radius: 5px;
            border: none;
            cursor: pointer;
            outline: none;
            background-color: var(--button-color-dark-blue);
        }
    }  
}

.arrow-enter-active,
.arrow-leave-active {
  transition: opacity 0.5s;
}
.arrow-enter,
.arrow-leave-to {
  opacity: 0;
}
</style>